import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useMenus } from '~/contexts/menu.context';
import { resolveSmarPanelBackOfficeUrl } from '../utils/smarPanelBackOfficeUrl';

export function useSmarPanelBackOfficeUrl() {
  const location = useLocation();
  const { menus } = useMenus();
  const chaveCliente = useSelector(state => state.configuration.ChaveCliente);
  const razaoSocial = useSelector(state => state.configuration.RazaoSocial);

  return useMemo(() => {
    return resolveSmarPanelBackOfficeUrl({
      portalPath: location.pathname,
      menus,
      handshake: {
        chaveCliente,
        razaoSocial,
      },
    });
  }, [location.pathname, menus, chaveCliente, razaoSocial]);
}
